import React from "react"
import { GraphqlProvider } from "design_system/utils/graphql_client"
import { ThemeProvider, createTheme } from "flowbite-react"
import { BrowserRouter } from "react-router"
import { FloatingMenuProvider } from "@love-irish/application-floating-menu"
import SessionProvider from "@love-irish/application-session-provider"
import PagePropsProvider from "@love-irish/application-page-context"
import AppSuggestionProvider from "./app_suggestion_provider"

import { useEffect, useRef } from "react"

const customTheme = createTheme({
  label: {
    root: {
      base: "text-sm font-bold",
    },
  },
  textInput: {
    field: {
      input: {
        colors: {
          gray: "border-gray-300 bg-background text-gray-900 focus:border-cyan-500 focus:ring-cyan-500 dark:border-gray-600 dark:text-white dark:placeholder-gray-400 dark:focus:border-cyan-500 dark:focus:ring-cyan-500",
        },
      },
    },
  },
})

const UrlHashScrollRestorer = ({ children }) => {
  // These pages are loaded in a suspense call so we need to restore scroll for url-targeted items from the hash
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "")
      const element = document.getElementById(id)
      if (element) {
        element.scrollIntoView({ behavior: "smooth" })
      }
    }
  }, [])

  return children
}

export default function AppShell({
  children,
  currentUser,
  currentProfile,
  renderActionMenu = true,
  pageProps,
}) {
  // Fullscreen pages (the layout's `fullscreen?`, surfaced via page props) drop the floating action
  // menu automatically, so a page doesn't need its own renderActionMenu override to go chromeless.
  const showActionMenu =
    renderActionMenu && pageProps?.renderContext !== "fullscreen"

  return (
    <GraphqlProvider>
      <PagePropsProvider value={pageProps}>
        <SessionProvider
          currentProfile={currentProfile}
          currentUser={currentUser}
        >
          <BrowserRouter>
            <ThemeProvider theme={customTheme}>
              {/* Shared "Help me write" registry + pick overlay. Wraps the FAB and the page so the Grug menu
                  and the page's tagged fields live in one React tree / one registry. */}
              <AppSuggestionProvider>
                <FloatingMenuProvider renderActionMenu={showActionMenu}>
                  <UrlHashScrollRestorer>{children}</UrlHashScrollRestorer>
                </FloatingMenuProvider>
              </AppSuggestionProvider>
            </ThemeProvider>
          </BrowserRouter>
        </SessionProvider>
      </PagePropsProvider>
    </GraphqlProvider>
  )
}
